<div class="row" *ngIf="message != ''">
  <div class="col-12">
    <div class="information_box {{localService.selectedLanguageCode}}" [ngClass]="isRedAlert ? 'red_alert' : ''">
      <i class="material-icons information_box_icon icon_adjust">mail</i>
      <span style="padding: 10px;">{{message}}</span>
      <i class="material-icons icon_adjust close" (click)="onClose()" title="{{localService.languageContent.common.close}}">add_circle_outline</i>
    </div>
  </div>
</div>
